import { Routes } from '@angular/router';
import { APP_ROUTES } from './config/app-routes.config';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { TranslationFieldComponent } from './components/translation-field/translation-field.component';
import { RephraseComponent } from './components/rephrase/rephrase.component';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../environments/environment';

export function createAppRoutes(features: typeof environment.features): Routes {
  const translationRoutes: Routes = features.textTranslation
    ? [
        {
          path: APP_ROUTES.root,
          component: TranslationFieldComponent,
          pathMatch: 'full',
          canActivate: [MsalGuard],
        },
        {
          path: APP_ROUTES.textTranslation,
          component: TranslationFieldComponent,
          pathMatch: 'full',
          canActivate: [MsalGuard],
        },
      ]
    : [
        {
          path: APP_ROUTES.root,
          redirectTo: APP_ROUTES.fileUpload,
          pathMatch: 'full',
        },
        {
          path: APP_ROUTES.textTranslation,
          redirectTo: APP_ROUTES.fileUpload,
          pathMatch: 'full',
        },
      ];

  const rephraseRoute: Routes = features.textRephrase
    ? [
        {
          path: APP_ROUTES.textRephrase,
          component: RephraseComponent,
          pathMatch: 'full',
          canActivate: [MsalGuard],
        },
      ]
    : [
        {
          path: APP_ROUTES.textRephrase,
          redirectTo: APP_ROUTES.fileUpload,
          pathMatch: 'full',
        },
      ];

  return [
    ...translationRoutes,
    {
      path: APP_ROUTES.fileUpload,
      component: FileUploadComponent,
      pathMatch: 'full',
      canActivate: [MsalGuard],
    },
    ...rephraseRoute,
  ];
}

export const routes: Routes = createAppRoutes(environment.features);
